import { axiosAjax } from '@app/src/config/axios';
import { hydrateDetail } from './hydrators';
import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';
import { getSettings } from '@app/src/configuration/config.service';

export const serviceDetail = {
  async getData(values: object, url: string) {
    try {
      let token = sessionStorage.getItem('accessToken');
      let idService = decodeAccessToken('idService');
      const { data } = await axiosAjax.get(url, {
        params: {
          serviceId: idService,
          ...values
        },
        headers: { Authorization: `Bearer ${token}` }
      });
      return hydrateDetail(data);
    } catch(error) {
      throw error.response.data;
    }
  }
}

export const serviceRefreshToken = {
  async getData(refreshToken) {
    try {
      const expToken = sessionStorage.getItem('accessToken');
      const { data, headers } = await axiosAjax.post(getSettings().API_REFRESH_TOKEN, { refreshToken, expToken });
      const refreshtoken = headers.authorization;
      localStorage.setItem('refreshtoken', refreshtoken);
      if(data.code == 100){
        sessionStorage.setItem('accessToken', data.data.accessToken);
        sessionStorage.setItem('reportToken', data.data.reportToken);
        return data;
      }else{
        throw new Error(data.message);
      }
    } catch (e) {
      throw e.response.data;
    }
  }
}
